import "../components/leaderboard-panel";
import "../components/loader";
import CCCLeaderboardPanel from "../components/leaderboard-panel";
import { VanillaPagesType } from "../core/types/VanillaPages";
import { scrambleArray, selectAnchor } from "../core/utilities";
import LeaderboardModel from "../models/LeaderboardModel";

export default class LeaderboardSinglePageController {
  htmlAnchor: HTMLElement = null;
  private paneLimit = 4;

  init(type: VanillaPagesType, anchor: string): void {
    switch (type) {
      case VanillaPagesType.custompage:
        this._initForCustomPage(anchor);
        break;
      default:
        throw "Leaderboard - Not a valid type";
        break;
    }
  }

  private async _initForCustomPage(anchor: string) {
    this.htmlAnchor = selectAnchor(anchor);
    if (this.htmlAnchor) {
      try {
        // load the dom anchor
        this.htmlAnchor.innerHTML = "<div class='loading size-6'></div>";
        // load the Leaderboard data, separated by level
        const data = await LeaderboardModel.getLeaderboardPerLevel();
        // delete content insideanchor
        this.htmlAnchor.innerHTML = "";
        const limit =
          data.length > this.paneLimit ? this.paneLimit : data.length;
        for (let i = 0; i < limit; i++) {
          const leaderboard = data[i];
          // console.log(leaderboard);
          // create a dom element per level
          const leaderBoardPanel: CCCLeaderboardPanel = document.createElement(
            "ccc-leaderboard-panel"
          ) as CCCLeaderboardPanel;
          // apply the data to the component
          //leaderBoardPanel.setAttribute("title", leaderboard.type);
          leaderBoardPanel.setState({
            level: leaderboard.type,
            items: scrambleArray(leaderboard.items),
          });
          // append to dom anchor
          // console.log(leaderBoardPanel);
          this.htmlAnchor.append(leaderBoardPanel);
        }
      } catch (err) {
        console.error(err);
      }
    } else {
      console.error(`Leaderboard - ${anchor} element not found in DOM`);
    }
  }
}
